import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  imports: [FormsModule, CommonModule],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit {
  phoneNumber: string = '';
  password: string = '';
  rememberMe: boolean = false;
  errorMessage: string = '';
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      window.history.replaceState({}, document.title, window.location.pathname);
      this.isLoading = true;
      this.authService.loginWithToken(token).then(() => {
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
        this.errorMessage = 'Token login failed. Please log in manually.';
      });
    }
  }

  onSubmit() {
    if (this.phoneNumber && this.password) {
      this.isLoading = true;
      this.errorMessage = '';

      this.authService.login(this.phoneNumber, this.password).subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.success) {
            this.router.navigate(['/trainers']);
          } else {
            this.errorMessage = response.message;
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = error.error?.message || 'An error occurred during login. Please try again.';
        }
      });
    } else {
      this.errorMessage = 'Please enter your phone number and password.';
    }
  }

  signInWithGoogle() {
    // Google Sign-In not implemented yet
    console.log('Google Sign-In clicked');
  }
}
